/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Badge, NumberFormatter } from '@mantine/core';
import AppFlexbox from '../../../../../common/AppFlexbox';
import AppText from '../../../../../common/AppText';
import { roundUpToCentValue } from '../../../../../../helpers/format';

const WsPriceBlock = ({
  config,
  selectedVariants,
  selectedVariantsInfo,
  ecomStoreProduct
}) => {
  const pricing = (selectedVariantsInfo || []).reduce(
    (r, c) => {
      const bundlePrice = c.selectedVariant.ecomStoreProductVariantDiscountPrices?.find(
        (p) =>
          p.fkEcomStoreProductPackage ===
          ecomStoreProduct.ecomStoreProductPackage?.pkEcomStoreProductPackage
      )?.price;
      const price = bundlePrice || c.selectedVariant.price;

      return {
        pricingNotFound:
          r.pricingNotFound ||
          (ecomStoreProduct.ecomStoreProductPackage && !bundlePrice),
        price: r.price + price * c.count,
        compareAtPrice:
          r.compareAtPrice + c.selectedVariant.compareAtPrice * c.count
      };
    },
    {
      price: 0,
      compareAtPrice: 0,
      pricingNotFound: false
    }
  );

  return (
    selectedVariants &&
    selectedVariants.length > 0 &&
    !pricing.pricingNotFound && (
      <AppFlexbox style={{ alignItems: 'end', gap: 10 }}>
        {pricing.compareAtPrice > 0 && (
          <AppText
            style={{
              fontSize: 18,
              fontWeight: 450,
              color: '#999',
              textDecoration: 'line-through'
            }}
          >
            <NumberFormatter
              decimalScale={2}
              fixedDecimalScale
              prefix="$"
              suffix=" CAD"
              thousandSeparator
              value={pricing.compareAtPrice / 100}
            />
          </AppText>
        )}
        <AppFlexbox style={{ alignItems: 'center', gap: 10 }}>
          <AppText style={{ fontSize: 22, fontWeight: 450 }}>
            <NumberFormatter
              decimalScale={2}
              fixedDecimalScale
              prefix="$"
              suffix=" CAD"
              thousandSeparator
              value={
                ecomStoreProduct.ecomStoreProductPackage
                  ? roundUpToCentValue(
                      pricing.price / 100,
                      ecomStoreProduct.ecomStoreProductPackage
                        .roundingAdjustment / 100
                    )
                  : pricing.price / 100
              }
            />
          </AppText>
          {pricing.compareAtPrice > 0 && (
            <Badge color="dark" size="lg" variant="filled">
              Sale
            </Badge>
          )}
        </AppFlexbox>
      </AppFlexbox>
    )
  );
};

WsPriceBlock.propTypes = {
  config: PropTypes.object,
  ecomStoreProduct: PropTypes.object,
  selectedVariants: PropTypes.array,
  selectedVariantsInfo: PropTypes.array
};

export default WsPriceBlock;
